import { performRESTRequest } from "@ng-mw/framework-core"
import { CampaignDetails } from "../types/CampaignAdminTypes"

export const getCampaignById = async (
    storeId: string,
    campaignId: number,
): Promise<CampaignDetails | undefined> => {
    if (!(Boolean(storeId) && Number.isFinite(campaignId) && campaignId > 0)) {
        return undefined
    }

    const response = await performRESTRequest({
        method: "GET",
        path: `/api/products/{chainid}/${storeId}/campaigns/${campaignId}`,
    })

    const responseTyped = response as CampaignDetails

    return responseTyped
}
